export function useApi(csrfToken) {
  const headers = () => ({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-CSRF-Token': csrfToken || document.querySelector('meta[name="csrf-token"]')?.content || '',
  })

  async function request(method, url, body = null) {
    const opts = { method, headers: headers(), credentials: 'same-origin' }
    if (body) opts.body = JSON.stringify(body)

    const response = await fetch(url, opts)
    const data = response.status === 204 ? null : await response.json()

    if (!response.ok) {
      const error = new Error(data?.error || data?.errors?.join(', ') || 'Request failed')
      error.status = response.status
      error.data = data
      throw error
    }

    return data
  }

  return {
    get: (url) => request('GET', url),
    post: (url, body) => request('POST', url, body),
    put: (url, body) => request('PUT', url, body),
    patch: (url, body) => request('PATCH', url, body),
    delete: (url) => request('DELETE', url),
    getWorkspaceHealth: (workspaceSlug) => request('GET', `/api/workspaces/${encodeURIComponent(workspaceSlug)}/health`),
    createBadgeToken: (workspaceSlug) => request('POST', `/api/workspaces/${encodeURIComponent(workspaceSlug)}/health/badge_token`),
    buryCorpses: (workspaceSlug) => request('POST', `/api/workspaces/${encodeURIComponent(workspaceSlug)}/health/bury_corpses`),
    shipWorkspace: (workspaceSlug, { label, url }) => request('POST', `/api/workspaces/${encodeURIComponent(workspaceSlug)}/health/ship`, { label, url }),
    setShipCandidate: (workspaceSlug, taskId) => request('PUT', `/api/workspaces/${encodeURIComponent(workspaceSlug)}/health/ship_candidate`, { task_id: taskId }),
    dismissSellNudge: (workspaceSlug) => request('POST', `/api/workspaces/${encodeURIComponent(workspaceSlug)}/health/dismiss_sell`),
  }
}
